import React from 'react';
import { Box, Typography } from '@mui/material';

import { Address } from '../types/company.types';

import AddressSection from '@/features/apps/components/address-section';
import { PaperBoxStyles } from '@/components/styles';

interface CurrentAddressSectionProps {
  currentAddress: Address;
  originalCurrentAddress?: Address;
  onUpdateAddressField: (field: keyof Address, value: string) => void;
  getFieldError: (fieldName: string) => string | undefined;
  isFieldValid: (fieldName: string) => boolean;
}

export const CurrentAddressSection: React.FC<CurrentAddressSectionProps> = ({
  currentAddress,
  originalCurrentAddress,
  onUpdateAddressField,
  getFieldError,
  isFieldValid,
}) => {
  // Provide default values if address is undefined
  const safeAddress = currentAddress || {
    postalCode1: '',
    postalCode2: '',
    address1: '',
    address2: '',
    address3: '',
    phone: '',
    fax: '',
  };

  return (
    <PaperBoxStyles elevation={1} sx={{ mb: 3, paddingBottom: '32px' }}>
      <Typography
        variant='h5'
        sx={{
          mb: 3,
          color: '#1A1C20',
          fontSize: '22px',
          fontWeight: 600,
        }}
      >
        所在地情報
      </Typography>

      <Box>
        <Typography
          variant='h6'
          sx={{
            mb: 3,
            color: '#1A1C20',
            fontSize: '16px',
            fontWeight: 500,
          }}
        >
          所在地
        </Typography>

        {/* Postal Code */}
        <AddressSection
          safeAddress={safeAddress}
          originalSafeAddress={originalCurrentAddress}
          onUpdateAddressField={onUpdateAddressField}
          getFieldError={getFieldError}
          isFieldValid={isFieldValid}
          addressType='currentAddress'
        />
      </Box>
    </PaperBoxStyles>
  );
};
